import { IntercomService } from './intercom.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: [ './dashboard.component.scss' ],
})
export class DashboardComponent implements OnInit {

  isSidebarOpen: boolean = false;

  constructor(private intercomService: IntercomService) {
  }

  ngOnInit() {
    this.intercomService.initialize();
  }

  onSidebarChanged(event: boolean) {
    this.isSidebarOpen = event;
  }
}
